import * as ModelAPI from "api/ModelAPI";
import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";

const UPDATE_FIELD = "oldProject/UPDATE_FIELD";

const initialState = {
  step: "dataset",
  success: undefined,
  lastRunId: "new"
};

function oldProjectReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

export function getProject(state) {
  return state.oldProject;
}

export function getStep(state) {
  return getProject(state).step;
}

export function getSuccess(state) {
  return getProject(state).success;
}

export function getLastRunId(state) {
  return getProject(state).lastRunId;
}

export function updateStep(step) {
  return { type: UPDATE_FIELD, data: step, key: "step" };
}

export function updateSuccess(success) {
  return { type: UPDATE_FIELD, data: success, key: "success" };
}

export function updateLastRunId(lastRunId) {
  return { type: UPDATE_FIELD, data: lastRunId, key: "lastRunId" };
}

export function updateModelName(id, label) {
  return (dispatch, getState) => {
    if (id === "new") {
      return dispatch(setupReducer.updateLabel(id, label));
    }
    if (setupReducer.getLabel(getState(), id) !== label) {
      ModelAPI.updateRun(id, {
        name: label
      }).then((response) => {
        let newJob = runReducer.parseJob(dispatch, response);
        dispatch(runReducer.updateJob(response.id, newJob));
      });
    }
  };
}

export default oldProjectReducer;
